export default __webpack_public_path__ + "static/studio-slider-10-d4578f7cb776ae871c9b9a7ae7c60b20.png";